export enum EnumSubscriptionStatus {
  INACTIVE = 0,
  ACTIVE = 1,
}